import React from 'react';

const Random = (props) => {
    console.log(props)
    
    
    
    return (
        <div>
            <h3>
              Randomly Selected
            </h3>
        </div>
    );
};

export default Random;